import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { MatChipsModule } from '@angular/material/chips';
import { AutomationReplacementChipsComponent } from '../../../../common/components';
import { StaticSelectorService } from '../../../../data-services/static-selector.service';

export const sleepWeekdays = 'sleepWeekdays';

@Component({
  selector: 'automata-weekday-selector',
  template: `
    <automata-automation-replacement-chips
      [dataService]="staticSelectorService"
      [formControl]="formControl"
      [isRequired]="true"
      [multiple]="true"
      [supportDataPassing]="false"
      [bottomSpacing]="bottomSpacing"
      [showLabel]="showLabel"
    ></automata-automation-replacement-chips>
  `,
  imports: [
    CommonModule,
    TranslateModule,
    MatChipsModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyInputModule,
    AutomationReplacementChipsComponent,
  ],
})
export class WeekdaySelectorComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() sleepWeekdays: string[];
  @Input() bottomSpacing: 'default' | 'small' | 'none' | false = 'default';
  @Input() showLabel = true;

  formControl?: FormControl;

  chips = new Map<string, string>([
    ['sunday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.SUNDAY'],
    ['monday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.MONDAY'],
    ['tuesday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.TUESDAY'],
    ['wednesday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.WEDNESDAY'],
    ['thursday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.THURSDAY'],
    ['friday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.FRIDAY'],
    ['saturday', 'AUTOMATIONS.EDITOR.TASKS.DELAY.SATURDAY'],
  ]);
  staticSelectorService = new StaticSelectorService<string>(this.chips, this.translateService);

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.formControl = new FormControl<string[]>(this.sleepWeekdays);
    this.form.addControl(sleepWeekdays, this.formControl);
  }

  isSelected(chip: any) {
    const weekdays: string[] = this.form.get(sleepWeekdays)!.value;
    return weekdays.includes(chip);
  }
}
